import { Product } from '../../types';
export var Environment = /*#__PURE__*/function (Environment) {
  Environment["Staging"] = "stg";
  Environment["Production"] = "prod";
  return Environment;
}({});

/**
 * Resolves product environment type,
 * Falls back to Environment.Staging
 *
 * !!! Trello only, other products to be added
 *
 * @param origin
 */
export var getEnvName = function getEnvName() {
  var _window;
  var origin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.origin;
  return ['https://trello.com'].includes(origin) ? Environment.Production : Environment.Staging;
};
var getProduct = function getProduct(product) {
  if (product) {
    var lowerJira = Product.JIRA.toLowerCase();
    var lowerProduct = product.toLowerCase();
    if (lowerProduct.includes(lowerJira)) {
      return lowerJira;
    }
    return lowerProduct;
  }
};
export var getLoginUrl = function getLoginUrl(productType) {
  var env = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getEnvName();
  var continueUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : String(window.location);
  var loginHint = arguments.length > 3 ? arguments[3] : undefined;
  var baseUrl = env === Environment.Production ? 'https://id.atlassian.com/login' : 'https://id.stg.internal.atlassian.com/login';
  var product = getProduct(productType);
  return "".concat(baseUrl, "?continue=").concat(encodeURIComponent(continueUrl)).concat(product ? "&application=".concat(encodeURIComponent(product)) : '', "\n  ").concat(loginHint ? "&login_hint=".concat(encodeURIComponent(loginHint)) : '');
};